/**
 * `<tt-acabado-nombre>` — el nombre del acabado que hay elegido en una tarjeta de producto.
 *
 * Por que existe (`plan/16` §4.3): las muestras solas no dicen que color se esta mirando. Montana
 * y USM escriben «Colour: X» debajo de la tarjeta, y es lo que convierte seis circulos en
 * informacion. El tema pinta las muestras (bloque `swatches`) pero no el nombre.
 *
 * El nombre correcto ya viene servido desde Liquid, asi que sin JS la tarjeta sigue siendo
 * correcta; esto solo lo mantiene al dia cuando el visitante pasa por encima de una muestra o
 * elige otra.
 */
class TtAcabadoNombre extends HTMLElement {
  connectedCallback() {
    this.tarjeta = this.closest('product-card') ?? this.closest('li') ?? document;
    this.inicial = this.textContent.trim();

    // `change` sube desde los radios de la muestra; los dos de puntero no burbujean, de ahi
    // `capture`. Un solo juego de escuchas por tarjeta, en la tarjeta, no en cada muestra.
    this.tarjeta.addEventListener('change', this.#alCambiar);
    this.tarjeta.addEventListener('pointerenter', this.#alEntrar, true);
    this.tarjeta.addEventListener('pointerleave', this.#alSalir, true);
  }

  disconnectedCallback() {
    this.tarjeta?.removeEventListener('change', this.#alCambiar);
    this.tarjeta?.removeEventListener('pointerenter', this.#alEntrar, true);
    this.tarjeta?.removeEventListener('pointerleave', this.#alSalir, true);
  }

  /** Nombre del valor de opcion de una muestra, sea el radio o su etiqueta. */
  #nombreDe(elemento) {
    const radio = elemento?.matches?.('input[type="radio"]') ? elemento : elemento?.querySelector?.('input[type="radio"]');
    return radio?.getAttribute('aria-label')?.trim() || radio?.value?.trim() || null;
  }

  #pinta(nombre) {
    if (nombre && nombre !== this.textContent.trim()) this.textContent = nombre;
  }

  #alCambiar = (evento) => {
    const nombre = this.#nombreDe(evento.target);
    if (!nombre) return;
    this.elegido = nombre; // el elegido manda: al salir del hover se vuelve aqui
    this.#pinta(nombre);
  };

  #alEntrar = (evento) => {
    const etiqueta = evento.target?.closest?.('.variant-option__swatch');
    if (etiqueta) this.#pinta(this.#nombreDe(etiqueta));
  };

  #alSalir = (evento) => {
    if (!evento.target?.closest?.('.variant-option__swatch')) return;
    this.#pinta(this.elegido || this.inicial);
  };
}

if (!customElements.get('tt-acabado-nombre')) {
  customElements.define('tt-acabado-nombre', TtAcabadoNombre);
}
